import { minifyGraphQL } from '@/lib/helper/minifyGraphql';

export const menuFragment = minifyGraphQL(`menu {
        primaryMenuItems {
          name
          slug
          linkType
          url
          content {
            id
            title
            type
            slug
          }
          liveCoverage{
              id
          }
          page {
            slug
          }
            topic{
            page {
            slug
            }
            }
          id
           tvShow {
                id
              }
          description
          menuItems {
            name
            slug
            linkType
            url
             tvShow {
                id
              }
            content {
              id
              title
              type
              slug
            }
            topic{
            page {
            slug
            }
            }
            liveCoverage{
                id
            }
           
            page {
              slug
            }
            id
            description
          }
        }
        secondaryMenuItems {
          name
          slug
          linkType
          url
          content {
            id
            title
            type
            slug
          }
            tvShow {
                id
              }
          liveCoverage{
              id
          }
          page {
            slug
          }
            topic{
            page {
            slug
            }
            }
          id
          description
          menuItems {
          tvShow {
                id
              }
            name
            slug
            linkType
            url
            content {
              id
              title
              type
              slug
            }
            liveCoverage{
                id
            }
             topic{
            page {
            slug
            }
            }
            page {
              slug
            }
            id
            description
          }
        }
        title
}`);
